module.exports = __webpack_public_path__ + "img/ective_slim_230Ah.3855cc5b.png";